export default __webpack_public_path__ + "img/default-product-image.png";